// extracted by mini-css-extract-plugin
export default {"text":"styles_text__RoZwj","logo":"styles_logo__HfHwW"};